import {
  FC,
  memo,
  MouseEventHandler,
  Dispatch,
  SetStateAction,
  ReactElement,
  MouseEvent,
} from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { Group, Text, UnstyledButton } from "@mantine/core";

export type SegmentedControlProps = {
  options: string[];
  getIcon?: (choice: string) => ReactElement;
  selectedOption: string;
  setOption: Dispatch<SetStateAction<string>>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  hideLabel?: boolean;
};

const SegmentedControl: FC<SegmentedControlProps> = ({
  options,
  getIcon,
  selectedOption,
  setOption,
  onClick,
  hideLabel,
}) => {
  const handleClick = (
    event: MouseEvent<HTMLButtonElement>,
    clickedOption: string
  ) => {
    setOption(clickedOption);
    if (onClick) onClick(event);
  };

  return (
    <Group spacing={8}>
      {options.map((option) => {
        return (
          <UnstyledButton
            key={option}
            onClick={(event: MouseEvent<HTMLButtonElement>) =>
              handleClick(event, option)
            }
          >
            <BoxContainer
              p="sm"
              border={false}
              bg={option === selectedOption ? SECONDARY_COLOR : undefined}
            >
              <Group spacing={8} align="center">
                {getIcon && getIcon(option)}
                {!hideLabel && (
                  <Text size="sm" weight={500}>
                    {option}
                  </Text>
                )}
              </Group>
            </BoxContainer>
          </UnstyledButton>
        );
      })}
    </Group>
  );
};

export default memo(SegmentedControl);
